
<script>
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'TableKeyboardNav',
  data() {
    return {
      disableEnter: false
    }
  },
  mounted() {
    this.$el.addEventListener('keydown', this.cellKeydown)
    this.$el.addEventListener('paste', this.cellPaste)
  },
  beforeDestroy() {
    this.$el.removeEventListener('keydown', this.cellKeydown)
    this.$el.removeEventListener('paste', this.cellPaste)
  },
  methods: {
    cellKeydown(e) {
      const field = e.target.dataset
      e.stopPropagation()
      switch (e.keyCode) {
        case 9: {
          e.preventDefault()
          const { api, rowIndex } = this.params
          this.triggerBlur()
          setTimeout(() => {
            if (e.shiftKey) {
              api.tabToPreviousCell()
            } else {
              api.tabToNextCell()
            }
            api.setFocusedCell(rowIndex, api.getFocusedCell().column.colId)
            api.startEditingCell({ rowIndex, colKey: api.getFocusedCell().column.colId })
          }, 0)
          break
        }
        case 13: {
          if (this.disableEnter) {
            return
          }
          const { api, node, onCellLastNodeEnterKeydown, rowIndex, column } = this.params
          this.triggerBlur()
          setTimeout(() => {
            if (node.lastChild) {
              if (onCellLastNodeEnterKeydown && typeof onCellLastNodeEnterKeydown === 'function') {
                this.params.onCellLastNodeEnterKeydown(this.params)
              }
              console.log(api.getDisplayedRowAtIndex(rowIndex + 1))
              api.tabToNextCell()
              api.startEditingCell({ rowIndex, colKey: api.getFocusedCell().column.colId })
            } else {
              console.log(api.getDisplayedRowAtIndex(rowIndex + 1))
              api.setFocusedCell(rowIndex + 1, column.colId)
              api.startEditingCell({ rowIndex: rowIndex + 1, colKey: column.colId })
            }
          }, 0)
          break
        }
        case 37: {
          if (this.params.colDef && this.params.colDef.disableLeftRightKey) {
            return
          }
          if (field.code && field.code === 'hsCode') {
            return
          } else {
            const { api, rowIndex } = this.params
            this.triggerBlur()
            setTimeout(() => {
              api.tabToPreviousCell()
              api.startEditingCell({ rowIndex, colKey: api.getFocusedCell().column.colId })
            }, 0)
          }
          break
        }
        case 39: {
          if (this.params.colDef && this.params.colDef.disableLeftRightKey) {
            return
          }
          if (field.code && field.code === 'hsCode') {
            return
          } else {
            const { api, rowIndex } = this.params
            this.triggerBlur()
            setTimeout(() => {
              api.tabToNextCell()
              api.startEditingCell({ rowIndex, colKey: api.getFocusedCell().column.colId })
            }, 0)
          }
          break
        }
        case 38: {
          const { api, node, rowIndex, column } = this.params
          if (!node.firstChild) {
            this.triggerBlur()
            setTimeout(() => {
              api.setFocusedCell(rowIndex - 1, column.colId)
              api.startEditingCell({ rowIndex: rowIndex - 1, colKey: column.colId })
            }, 0)
          }
          break
        }
        case 40: {
          const { api, node, rowIndex, column } = this.params
          if (!node.lastChild) {
            this.triggerBlur()
            setTimeout(() => {
              api.setFocusedCell(rowIndex + 1, column.colId)
              api.startEditingCell({ rowIndex: rowIndex + 1, colKey: column.colId })
            }, 0)
          }
          break
        }
      }
    },
    cellPaste(e) {
      if (this.params.multiplePaste) {
        try {
          const pastedText = e.clipboardData.getData('text')
          if (typeof pastedText === 'string') {
            const nodes = this.params.api.getModel().rowsToDisplay
            const cell = this.params.api.getFocusedCell()
            // 统一处理换行符，将 \r\n 和 \r 都转换为 \n
            const normalizedText = pastedText.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
            const lines = normalizedText.trimEnd().split('\n')
            this.value = this.toCoverPaste(lines[0], this.params.multiplePaste)
            for (let i = 1; i < lines.length; i++) {
              const line = this.toCoverPaste(lines[i], this.params.multiplePaste)
              const curNode = nodes[cell.rowIndex + i]
              if (!curNode) {
                break
              }
              curNode.setDataValue(this.params.colDef.field, line)
            }
            e.preventDefault()
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    toCoverPaste(value, { isUppercase = false, isTrim = false, maxLength, isNumber = false, precision, min } = {}) {
      if (isUppercase) {
        value = value.toUpperCase()
      }
      if (isTrim) {
        value = value.trim()
      }
      if (maxLength > 0) {
        value = value.slice(0, maxLength)
      }
      if (isNumber) {
        // 复制A12.45NABC12进去，要变成12.4512。 需要保留数字以及小数点
        if (value) {
          value = String(value).replace(/[^\d.]/g, '')
        }
        value = Number(value) || 0
        if (typeof precision === 'number') {
          value = NumberUtils.ToFixed2(value, precision)
        }
        if (typeof min === 'number') {
          value = Math.max(value, min)
        }
      }
      return value
    },
    triggerBlur() {
      if (this.type === 'input') {
        this.$refs.input.blur()
      }
    }
  }
}
</script>
